export default __webpack_public_path__ + "static/media/src/assets/3d-objects/light.70730d9e.glb";